import he from 'he';

export function decodeHtmlEntities (input: string) {
  return he.decode(input);
}
